module.exports = __webpack_public_path__ + "static/img/60.9e706f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/60.png
// module id = DAL7
// module chunks = 0